export default [
    {
        "system": "Homeopáticos",
        "classes": [
            "Homeopáticos"
        ]
    },
    {
        "system": "Respiratórios",
        "classes": [
            "Descongestionante Nasal",
            "Expectorantes",
            "Antitussígenos",
            "Mucolíticos",
            "Broncodilatadores",
            "Anti-inflamatórios Esteroides Inaláveis",
            "Estimulantes Respiratórios"
        ]
    },
    {
        "system": "Musculoesqueléticos | Articulares",
        "classes": [
            "Aminoácidos",
            "Anti-inflamatórios não Esteroides",
            "Bifosfonatos",
            "Relaxantes Musculares",
            "Antirreumáticos",
            "Anticolinesterásicos: Manejo de Miastenia Gravis",
            "Suporte de Osteoartrite/Osteoartrose"
        ]
    },
    {
        "system": "Cardiovasculares",
        "classes": [
            "Manejo da Dirofilariose",
            "Antifibrinolíticos",
            "Hemostáticos",
            "Antianêmicos/Agentes Eritropoiéticos",
            "Antiarrítmicos",
            "Bloqueadores de Canal de Cálcio",
            "Anti-hipertensivos/Vasodilatadores",
            "Bloqueadores/Antagonistas Adrenérgicos",
            "Agonistas Adrenérgicos",
            "Anticolinérgicos",
            "Inibidores da Enzima Conversora de Angiotensina (ECA)",
            "Diuréticos",
            "Bloqueadores de Receptores de Angiotensina",
            "Inibidores de Agregação Plaquetária",
            "Digitálicos",
            "Atividade Inotrópica Positiva",
            "Inodilatadores",
            "Vasopressores/Anti-hipotensivos",
            "Anticoagulantes",
            "Expansores Plasmáticos",
            "Potencializadores de Perfusão Tissular"
        ]
    },
    {
        "system": "Antimicrobianos | Antiparasitários",
        "classes": [
            "Manejo da Dirofilariose",
            "Antimicrobianos - Hemoparasitoses",
            "Atividade Antiprotozoária",
            "Ectoparasiticidas",
            "Endoparasiticidas",
            "Ectoparasiticidas + Endoparasiticidas",
            "Antibióticos: Aminoglicosídeos",
            "Antibióticos: Macrolídeos",
            "Antibióticos: Penicilinas",
            "Antibióticos: Cefalosporinas",
            "Antibióticos: Fluoroquinolonas",
            "Antibióticos: Lincosamidas",
            "Antibióticos: Tetraciclinas",
            "Antibióticos: Carbapenêmicos",
            "Antibióticos: Sulfonamidas",
            "Antibióticos: Glicopeptídeos",
            "Antibióticos: Urinário restrito",
            "Antibióticos: Nitroimidazólicos",
            "Antibióticos: Diversos",
            "Antifúngicos",
            "Antimicobacterianos",
            "Antivirais",
            "Manejo da Leishmaniose"
        ]
    },
    {
        "system": "Hematológicos",
        "classes": [
            "Antimicrobianos - Hemoparasitoses",
            "Antifibrinolíticos",
            "Hemostáticos",
            "Antianêmicos/Agentes Eritropoiéticos",
            "Inibidores de Agregação Plaquetária",
            "Anticoagulantes",
            "Estimulantes de Colônia Granulocítica"
        ]
    },
    {
        "system": "Manejo Eletrolítico | Solutos Séricos",
        "classes": [
            "Quelantes Orais de Fósforo",
            "Repositores de Cálcio",
            "Repositores de Potássio",
            "Repositores de Magnésio",
            "Hiperglicemiantes não Esteroides",
            "Hormônios Hiperglicemiantes não Esteroides",
            "Bifosfonatos",
            "Hipolipemiantes",
            "Alcalinizantes Séricos"
        ]
    },
    {
        "system": "Renais | Urinários",
        "classes": [
            "Quelantes Orais de Fósforo",
            "Inibidores de Anidrase Carbônica",
            "Inibidores de Xantina Oxidase",
            "Antibióticos: Urinário restrito",
            "Anti-hipertensivos/Vasodilatadores",
            "Manejo de Retenção Urinária",
            "Inibidores da Enzima Conversora de Angiotensina (ECA)",
            "Manejo de Atonia de Bexiga",
            "Diuréticos",
            "Bloqueadores de Receptores de Angiotensina",
            "Incontinência Urinária: Estrógeno Responsiva",
            "Vasopressina e Análogos"
        ]
    },
    {
        "system": "Emergência | Intensivismo",
        "classes": [
            "Repositores de Cálcio",
            "Hiperglicemiantes não Esteroides",
            "Antioxidantes",
            "Antídotos",
            "Antagonistas Benzodiazepínicos",
            "Broncodilatadores",
            "Antiarrítmicos",
            "Bloqueadores/Antagonistas Adrenérgicos",
            "Antagonistas α-2 Adrenérgicos",
            "Agonistas Adrenérgicos",
            "Anticolinérgicos",
            "Antiepilépticos/Anticonvulsivantes",
            "Diuréticos",
            "Atividade Inotrópica Positiva",
            "Vasopressores/Anti-hipotensivos",
            "Estimulantes Respiratórios",
            "Reversores/Antagonistas Opioides",
            "Eméticos",
            "Expansores Plasmáticos",
            "Anticolinesterásicos"
        ]
    },
    {
        "system": "Gastrointestinais",
        "classes": [
            "Antiácidos Orais não Sistêmicos",
            "Endoparasiticidas",
            "Ectoparasiticidas + Endoparasiticidas",
            "Laxantes",
            "Fitoterápicos – TGI",
            "Antiespasmódicos",
            "Anti-histamínicos H2",
            "Manejo de Cinetose",
            "Procinéticos",
            "Inibidores de Bomba de Prótons",
            "Antidiarreicos",
            "Antieméticos",
            "Eméticos",
            "Antifiséticos",
            "Protetores de Mucosa do TGI",
            "Enzimas Digestivas"
        ]
    },
    {
        "system": "Endócrino | Metabolismo",
        "classes": [
            "Anti-hiperglicemiantes/Hipoglicemiantes",
            "Hiperglicemiantes não Esteroides",
            "Hormônios Hiperglicemiantes não Esteroides",
            "Sulfonilureias",
            "Antianêmicos/Agentes Eritropoiéticos",
            "Hipolipemiantes",
            "Anti-inflamatórios Esteroides/Corticosteroides",
            "Vitaminas",
            "Andrógenos",
            "Estrógenos",
            "Vasopressina e Análogos",
            "Antiandrogênicos",
            "Mineralocorticoides",
            "Progestágenos e Supressores de Estro",
            "Inibidores da Adrenocortical",
            "Análogos da Somatostatina",
            "Hormônios Tireoidianos"
        ]
    },
    {
        "system": "Anestesia | Sedação | Adjuvantes",
        "classes": [
            "Fenotiazínicos",
            "Benzodiazepínicos",
            "Antagonistas Benzodiazepínicos",
            "Antagonistas de NMDA",
            "Adjuvantes Analgésicos",
            "Bloqueadores/Antagonistas Adrenérgicos",
            "Antagonistas α-2 Adrenérgicos",
            "Agonistas α-2 Adrenérgicos",
            "Agonistas Adrenérgicos",
            "Bloqueadores Neuromusculares",
            "Anticolinérgicos",
            "Barbitúricos",
            "Anestésicos Locais",
            "Opioides",
            "Anestésicos",
            "Sedativos e Tranquilizantes",
            "Atividade Inotrópica Positiva",
            "Vasopressores/Anti-hipotensivos",
            "Estimulantes Respiratórios",
            "Reversores/Antagonistas Opioides"
        ]
    },
    {
        "system": "Neurológicos | Comportamentais",
        "classes": [
            "Inibidores de Anidrase Carbônica",
            "Estimulantes de Apetite",
            "Manejo de Ansiedade, Fobias e Distúrbios Comportamentais",
            "Antidepressivos Tricíclicos",
            "Manejo de Disfunção Cognitiva",
            "Feromônios",
            "Manejo de Retenção Urinária",
            "Antivertiginosos",
            "Manejo de Atonia de Bexiga",
            "Antiepilépticos/Anticonvulsivantes",
            "Manejo de Cinetose",
            "Antieméticos",
            "Anticolinesterásicos: Manejo de Miastenia Gravis",
            "Estimulantes do SNC e Nootrópicos",
            "Potencializadores de Perfusão Tissular"
        ]
    },
    {
        "system": "Analgésicos",
        "classes": [
            "Anti-inflamatórios não Esteroides",
            "Antagonistas de NMDA",
            "Adjuvantes Analgésicos",
            "Opioides"
        ]
    },
    {
        "system": "Anti-inflamatórios",
        "classes": [
            "Anti-inflamatórios não Esteroides",
            "Anti-inflamatórios Esteroides/Corticosteroides",
            "Anti-inflamatórios Esteroides Inaláveis"
        ]
    },
    {
        "system": "Hepatobiliares",
        "classes": [
            "Coleréticos",
            "Hepatoprotetores",
            "Dissolução de Cálculos Biliares"
        ]
    },
    {
        "system": "Dermatológicos Não Tópicos",
        "classes": [
            "Ectoparasiticidas",
            "Ectoparasiticidas + Endoparasiticidas",
            "Anti-histamínicos H1",
            "Retinóides",
            "Imunoterápicos Dermatológicos",
            "Inibidores de Janus Kinase"
        ]
    },
    {
        "system": "Reprodução | Obstetrícia",
        "classes": [
            "Bloqueadores de Progesterona/Abortivos",
            "Agonistas Dopaminérgicos",
            "Antagonistas Dopaminérgicos",
            "Prostaglandinas",
            "Andrógenos",
            "Estrógenos",
            "Tocolíticos",
            "Antiandrogênicos",
            "Progestágenos e Supressores de Estro",
            "Antigalactogênicos",
            "Manejo da Inércia Uterina",
            "Luteinizantes"
        ]
    },
    {
        "system": "Oncológicos",
        "classes": [
            "Antineoplásicos"
        ]
    },
    {
        "system": "Alergias | Hipersensibilidade",
        "classes": [
            "Agonistas Adrenérgicos",
            "Anti-inflamatórios Esteroides/Corticosteroides",
            "Anti-histamínicos H1",
            "Imunoterápicos Dermatológicos",
            "Inibidores de Janus Kinase"
        ]
    },
    {
        "system": "Imunossupressores | Imunomoduladores",
        "classes": [
            "Imunossupressores não Esteroides",
            "Anti-inflamatórios Esteroides/Corticosteroides",
            "Imunomoduladores"
        ]
    },
    {
        "system": "Diversos",
        "classes": [
            "Eutanásicos"
        ]
    }
]